import { forwardRef } from 'react';
import { ViewProps } from './ViewProps';
import { useViewProps } from './useViewProps';

export const View = forwardRef<HTMLDivElement, ViewProps>(function View(props, ref) {
  const { stopPropagation, ...restProps } = props;
  const { children, testID, ...rest } = useViewProps(restProps);

  return (
    <div
      ref={ref}
      data-testid={testID}
      onClick={stopPropagation ? stopEventPropagation : undefined}
      {...rest}
    >
      {children}
    </div>
  );
});

function stopEventPropagation(event: React.MouseEvent<HTMLDivElement>) {
  event.stopPropagation();
}
